import React, { useEffect, useState } from 'react';
import { Loader2, ClipboardList } from 'lucide-react';
import { atlasApi, AtlasUser, FeedbackPendencia } from '../shared/atlasApi';
import AvatarColaborador from '../shared/AvatarColaborador';

interface Props {
  user: AtlasUser;
  onResponder: (cicloId: string, funccodi: number, souEu: boolean) => void;
}

const MinhasPendencias: React.FC<Props> = ({ user, onResponder }) => {
  const [itens, setItens] = useState<FeedbackPendencia[]>([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState<string | null>(null);

  useEffect(() => {
    let cancel = false;
    atlasApi.minhasPendencias(user)
      .then(r => { if (!cancel) setItens(r.itens || []); })
      .catch(e => { if (!cancel) setErro(e.message || 'Erro ao carregar'); })
      .finally(() => { if (!cancel) setLoading(false); });
    return () => { cancel = true; };
  }, [user]);

  if (loading) return <div className="p-10 text-center text-gray-400"><Loader2 className="w-6 h-6 animate-spin mx-auto mb-2" /> Carregando...</div>;
  if (erro) return <div className="bg-rose-50 border border-rose-200 rounded-2xl p-6 text-rose-700">{erro}</div>;

  return (
    <div className="max-w-3xl">
      <h2 className="text-lg font-bold text-gray-900 flex items-center gap-2 mb-4"><ClipboardList className="w-5 h-5 text-rose-500" /> Minhas pendências</h2>
      {itens.length === 0 ? (
        <div className="bg-white rounded-2xl border border-gray-200 p-10 text-center text-gray-400">Nenhuma avaliação pendente. 🎉</div>
      ) : (
        <ul className="space-y-2">
          {itens.map((p, i) => (
            <li key={i} className="bg-white rounded-2xl border border-gray-200 p-4 flex items-center gap-3">
              <AvatarColaborador nome={p.avaliado_nome || `#${p.avaliado_funccodi}`} size={40} />
              <div className="flex-1 min-w-0">
                <div className="font-medium text-gray-900 truncate">
                  {p.sou_eu ? 'Autoavaliação' : (p.avaliado_nome || `Colaborador #${p.avaliado_funccodi}`)}
                </div>
                <div className="text-xs text-gray-400">{p.ciclo_titulo}{p.avaliado_cargo ? ` · ${p.avaliado_cargo}` : ''}</div>
              </div>
              <button onClick={() => onResponder(p.ciclo_id, p.avaliado_funccodi, p.sou_eu)} className="px-4 py-2 rounded-lg bg-purple-600 hover:bg-purple-700 text-white text-sm font-medium">
                Responder
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default MinhasPendencias;
